export enum ExternalSearchFieldEnum {
    cpf = 1,
    numeroCarteirinha = 2,
    cns = 3,
}